import React, { createContext, useContext, ReactNode } from 'react';
import { FeatureFlags } from '../types';

interface FeatureFlagContextType {
  features: FeatureFlags;
  isFeatureEnabled: (feature: keyof FeatureFlags) => boolean;
}

const FeatureFlagContext = createContext<FeatureFlagContextType | undefined>(undefined);

interface FeatureFlagProviderProps {
  children: ReactNode;
  features: FeatureFlags;
}

export const FeatureFlagProvider: React.FC<FeatureFlagProviderProps> = ({
  children,
  features
}) => {
  const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
    return features[feature] === true;
  };

  return (
    <FeatureFlagContext.Provider value={{ features, isFeatureEnabled }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagContext);
  if (context === undefined) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
  }
  return context;
};